import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';

export default class YesplanLocationUrlWrapper extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        domain: PropTypes.string,
        host: PropTypes.string
      }).isRequired
    }).isRequired
  };

  static defaultProps = {
    match: {
      host: null,
      domain: null
    }
  };

  constructor(props) {
    super();
    this.state = {
      domain: props.match.params.domain,
      host: props.match.params.host
    };

    this.routeUrlFor = this.routeUrlFor.bind(this);
    this.linkUrlFor = this.linkUrlFor.bind(this);
    this.redirectToYesplanLogin = this.redirectToYesplanLogin.bind(this);
    this.isValidUrl = this.isValidUrl.bind(this);
    this.redirectToUrl = this.redirectToUrl.bind(this);
  }

  linkUrlFor(url) {
    return `/${this.state.domain}/${this.state.host}${url}`;
  }

  redirectToUrl(linkUrl, options) {
    this.props.history.push({
      pathname: linkUrl,
      ...options
    });
  }

  routeUrlFor(url) {
    return `/:domain/:host${url}`;
  }

  redirectToYesplanLogin(isSignOut) {
    const redirectLocation =
      // Separate logic for testing and for production
      (this.state.domain === 'localhost'
        ? `http://localhost:${this.state.host}`
        : this.state.host === 'testklant'
        ? 'http://testklant.yesplan.app:8080'
        : `https://${this.state.host}.yesplan.${this.state.domain}`) +
      (isSignOut
        ? '/Yesplan/clearCookies'
        : `/Yesplan?${new URLSearchParams({
            redirectTo: window.location.href
          }).toString()}`);
    window.location = redirectLocation;
  }

  isValidUrl(url, hostUrl) {
    if (this.state.domain === 'localhost') {
      const [domain, host] = hostUrl.split(':');
      return url.startsWith(`/${domain}/${host}`);
    }
    const [host, yesplan, domain] = hostUrl.split('.');
    return url.startsWith(`/${domain}/${host}`);
  }

  render() {
    const { children } = this.props;

    const childrenWithProps = React.cloneElement(children, {
      linkUrlFor: this.linkUrlFor,
      routeUrlFor: this.routeUrlFor,
      redirectToYesplanLogin: this.redirectToYesplanLogin,
      isValidUrl: this.isValidUrl,
      redirectToUrl: this.redirectToUrl,
      ...omit(this.props, ['children']) /* Pass along props from other wrappers */
    });

    return childrenWithProps;
  }
}
